import { gql } from '@apollo/client';

export const UPDATE_ARBEITSBEREICH_STATION = gql(`
  mutation rotationsplan_updateArbeitsbereichStation($input: mitarbeiter_updateArbeitsbereichStationInput!) {
   mitarbeiter_updateArbeitsbereichStation(input: $input){
    error {
      message
    }
    success {
      station {
        ... on mitarbeiter_rotationsplanArbeitsbereichStation {
          von
          bis
          id
          lernziele
          bereichsleiter {
            id
            nachname
            vorname
            bildUrl
          }
          arbeitsbereich {
            id
            name
            markierung
          }
        }
      }
    }
  }
}
`);
